/* eslint-disable */

import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

export default {

    namespaced: true,
    state: {
        data: [],
    },
    mutations: {

    },
    actions: {

        async resolveTrackingLink({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.get(`/ct/${payload.linkID}`, { crossdomain: true });
                dispatch('alert/setLoaded', true, {root: true});
                return response;
            } catch(err) {
                console.log('Error resolving tracking link:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        }
    }
}
